import { render, staticRenderFns } from "./CompaniesList.vue?vue&type=template&id=1a2d28c5&scoped=true&"
import script from "./CompaniesList.vue?vue&type=script&lang=js&"
export * from "./CompaniesList.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesList.vue?vue&type=style&index=0&id=1a2d28c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2d28c5",
  null
  
)

export default component.exports